export default __webpack_public_path__ + "static/media/stats_bg.f490048a.jpg";